import {DirectionProvider} from '@base-ui/react/direction-provider';
import type {ReactNode} from 'react';

type VortexDirectionProviderProps = {
  children: ReactNode;
  element: Element;
};

/**
 * Keeps Base UI keyboard behavior aligned with the direction inherited by the
 * DOM tree hosting this React root. Reading the mount element also preserves
 * local `dir` overrides used by independently mounted Kiln components.
 */
export function VortexDirectionProvider({
  children,
  element,
}: VortexDirectionProviderProps) {
  /**
   * `element.dir` only reflects a local attribute; computed style also captures
   * direction inherited from an ancestor or supplied through CSS.
   */
  const direction =
    getComputedStyle(element).direction === 'rtl' ? 'rtl' : 'ltr';

  return (
    <DirectionProvider direction={direction}>{children}</DirectionProvider>
  );
}
